import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

export interface SimpleDialogProps {
  title?: React.ReactNode;
  description?: React.ReactNode;
  children?: React.ReactNode;
  open: boolean;
  onClose: VoidFunction;
}

export default function SimpleDialog({
  onClose,
  open,
  children,
  title,
  description,
}: SimpleDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>{description}</DialogContent>
      <DialogActions>{children}</DialogActions>
    </Dialog>
  );
}
